import { defineStore } from 'pinia';
import axiosAPIStore from './axiosAPI';
import axios from 'axios';

export default defineStore('sharedComponents Store', {
  state: () => ({
    share_status: false, // 分享狀態
    selected_shared_components: [], // 所選的分享元件
    selected_revoke_components: [], // 所選的收回元件
    share_filter_toggle: 0, // 可分享 與 已分享，開關
  }),
  actions: {}
})